import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function PopularRanking() {
  const ranked = [...comics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 10);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            热门排行
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {ranked.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 hover:bg-primary-50/50 transition-colors no-underline group cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                {index < 3 ? (
                  <span
                    className={`w-7 h-7 rounded-full flex items-center justify-center text-sm font-heading text-background-50 ${
                      index === 0
                        ? 'bg-primary-500'
                        : index === 1
                          ? 'bg-accent-500'
                          : 'bg-secondary-500'
                    }`}
                  >
                    {index + 1}
                  </span>
                ) : (
                  <span className="text-lg font-heading text-foreground-400">
                    {index + 1}
                  </span>
                )}
              </div>

              <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden bg-background-100">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 香香漫画热门排行`}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-0.5">{comic.author}</p>
                <div className="flex items-center gap-3 mt-1 flex-wrap">
                  <span className="text-xs text-foreground-500">
                    更新至{comic.chapters}话
                  </span>
                  <span className="text-xs text-accent-500">
                    <i className="ri-star-fill mr-0.5 w-3 h-3 inline-flex items-center justify-center"></i>
                    {comic.rating}
                  </span>
                </div>
              </div>

              <div className="flex-shrink-0 text-right">
                <p className="text-xs text-foreground-600">
                  <i className="ri-eye-line mr-0.5 w-3 h-3 inline-flex items-center justify-center"></i>
                  {(comic.views / 10000).toFixed(0)}万
                </p>
                <span
                  className={`inline-block mt-1 text-xs px-2 py-0.5 rounded ${
                    comic.status === '已完结'
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-primary-100 text-primary-700'
                  }`}
                >
                  {comic.status}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}